import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { Autocomplete } from "@material-ui/lab";
import {
  useStylesTF,
  useStylesTD,
  useStylesSetting,
} from "../../../St/comps/UseStyle";
import { useEffect } from "react";
import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from "@material-ui/core";
import Swipeable from "../../../Fronts/Main/Swipeable";
import axios from "axios";
import toast from "react-hot-toast";
import { uri } from "../../../help/Api";
import { sto } from "../../../Context/InshData";
import { useTranslation } from "react-i18next";

export default function ElectronicScaleForm(props) {
  const { object, data, onChange } = props;
  const { t } = useTranslation(["forms", "translation"]);

  const clasTF = useStylesTF();

  const [submiting, setSubmiting] = useState(false);

  const applyTaxGroup = async (taxGroupId) => {
    console.log(taxGroupId);
    const data = { id: taxGroupId,db_name: sto.db_name  };
    setSubmiting(true);
    await axios
      .post(uri + "SysSettings", data)
      .then((res) => {
        toast.success(t("default-tax-applied"));
      })
      .catch((err) => {
        toast.error(t("apply-failed"));
        console.log(err);
      });

    setSubmiting(false);
  };

  const onChangeData = (propName) => (e) => {
    onChange(null, { name: [propName], value: e.target.value });
  };
  const classesStt = useStylesSetting();

  return (
    <React.Fragment>
      <Grid container item lg={12} md={12} sm={12} xs={12}>
        <Grid item lg={6} md={6} sm={6} xs={6}>
          <TextField
            variant="outlined"
            size="small"
            id="id"
            label={t("code")}
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder={t("code")}
            type="text"
            InputLabelProps={{ shrink: true }}
            name="id"
            value={object.id}
            onChange={onChangeData("id")}
          />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={6}>
          <TextField
            variant="outlined"
            size="small"
            id="searchInvsx`"
            label={t("design-name")}
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder={t("design-name")}
            type="text"
            InputLabelProps={{ shrink: true }}
            name="mizan_desc"
            value={object.mizan_desc}
            onChange={onChangeData("mizan_desc")}
          />
        </Grid>
      </Grid>
      <Grid container item lg={12} md={12} sm={12} xs={12}>
        <Grid item lg={6} md={6} sm={6} xs={6}>
          <TextField
            variant="outlined"
            size="small"
            id="mizan_start_with`"
            label={t("barcode-start-number")}
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder={t("barcode-start-number")}
            type="text"
            InputLabelProps={{ shrink: true }}
            name="mizan_start_with"
            value={object.mizan_start_with}
            onChange={onChangeData("mizan_start_with")}
          />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={6}>
          <TextField
            variant="outlined"
            size="small"
            id="mizan_start_lenght`"
            label={t("start-number-length")}
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder={t("start-number-length")}
            type="text"
            InputLabelProps={{ shrink: true }}
            name="mizan_start_lenght"
            value={object.mizan_start_lenght}
            onChange={onChangeData("mizan_start_lenght")}
          />
        </Grid>
      </Grid>
      <Grid container item lg={12} md={12} sm={12} xs={12}>
        <Grid item lg={6} md={6} sm={6} xs={6}>
          <TextField
            variant="outlined"
            size="small"
            id="barcode_start_from`"
            label={t("item-barcode-start")}
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder={t("item-barcode-start")}
            type="text"
            InputLabelProps={{ shrink: true }}
            name="barcode_start_from"
            value={object.barcode_start_from}
            onChange={onChangeData("barcode_start_from")}
          />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={6}>
          <TextField
            variant="outlined"
            size="small"
            id="barcode_start_lenght`"
            label={t("item-barcode-length")}
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder={t("item-barcode-length")}
            type="text"
            InputLabelProps={{ shrink: true }}
            name="barcode_start_lenght"
            value={object.barcode_start_lenght}
            onChange={onChangeData("barcode_start_lenght")}
          />
        </Grid>
      </Grid>
      <Grid container item lg={12} md={12} sm={12} xs={12}>
        <Grid item lg={6} md={6} sm={6} xs={6}>
          <TextField
            variant="outlined"
            size="small"
            id="weight_start_from`"
            label={t("weight-barcode-start")}
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder={t("weight-barcode-start")}
            type="text"
            InputLabelProps={{ shrink: true }}
            name="weight_start_from"
            value={object.weight_start_from}
            onChange={onChangeData("weight_start_from")}
          />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={6}>
          <TextField
            variant="outlined"
            size="small"
            id="weight_start_lenght`"
            label={t("weight-barcode-length")}
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder={t("weight-barcode-length")}
            type="text"
            InputLabelProps={{ shrink: true }}
            name="weight_start_lenght"
            value={object.weight_start_lenght}
            onChange={onChangeData("weight_start_lenght")}
          />
        </Grid>
      </Grid>
      <Grid container item lg={12} md={12} sm={12} xs={12}>
        <Grid item lg={6} md={6} sm={6} xs={6}>
          <TextField
            variant="outlined"
            size="small"
            id="mizan_end_with`"
            label={t("scale-end-number")}
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder=""
            type="text"
            InputLabelProps={{ shrink: true }}
            name="mizan_end_with"
            value={object.mizan_end_with}
            onChange={onChangeData("mizan_end_with")}
          />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={6}>
          <TextField
            variant="outlined"
            size="small"
            id="mizan_end_lenght`"
            label={t("end-number-length")}
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder={t("end-number-length")}
            type="text"
            InputLabelProps={{ shrink: true }}
            name="mizan_end_lenght"
            value={object.mizan_end_lenght}
            onChange={onChangeData("mizan_end_lenght")}
          />
        </Grid>
      </Grid>
      <Grid container item lg={12} md={12} sm={12} xs={12} spacing={1}>
        <Grid item lg={6} md={6} sm={6} xs={6}>
          <TextField
            variant="outlined"
            size="small"
            id="total_barcode_lenght`"
            label={t("total-barcode-length")}
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder=""
            type="text"
            InputLabelProps={{ shrink: true }}
            name="total_barcode_lenght"
            value={object.total_barcode_lenght}
            onChange={onChangeData("total_barcode_lenght")}
          />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={6}>
          <TextField
            variant="outlined"
            size="small"
            id="price_start_from`"
            label={t("price-barcode-start")}
            InputProps={{ className: clasTF.input }}
            placeholder=""
            type="number"
            InputLabelProps={{ shrink: true }}
            name="price_start_from"
            value={object?.price_start_from}
            onChange={onChangeData("price_start_from")}
          />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={6}>
          <TextField
            variant="outlined"
            size="small"
            id="price_start_lenght`"
            label={t("price-barcode-length")}
            InputProps={{ className: clasTF.input }}
            placeholder=""
            type="number"
            InputLabelProps={{ shrink: true }}
            name="price_start_lenght"
            value={object?.price_start_lenght}
            onChange={onChangeData("price_start_lenght")}
          />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={6}>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    fullWidth
                    checked={object?.use_weight_and_price == 1?true:false}
                    onChange={(e) =>
                      onChange(null, {
                        name: "use_weight_and_price",
                        value: e.target.checked ? 1 : 0,
                      })
                                         
                    }
                    name="use_weight_and_price"
                  />
                }
                size="small"
                color="primary"
                fontSize="small"
                label={t("use-weight-and-price")}
              />
            </FormGroup>
          </Grid>
        <Grid container item lg={6} md={6} sm={6} xs={6}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    fullWidth
                    checked={object?.UseMizan == 1?true:false}
                    onChange={(e) =>
                      onChange(null, {
                        name: "UseMizan",
                        value: e.target.checked ? 1 : 0,
                      })
                    }
                    name="UseMizan"
                  />
                }
                size="small"
                color="primary"
                fontSize="small"
                label={t("use-electronic-scale")}
              />
            </FormGroup>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    fullWidth
                    checked={object?.use_weight_price == 1}
                    onChange={(e) =>
                      onChange(null, {
                        name: "use_weight_price",
                        value: e.target.checked ? 1 : 0,
                      })
                    }
                    name="use_weight_price"
                  />
                }
                size="small"
                color="primary"
                fontSize="small"
                label={t("use-weight-as-price")}
              />
            </FormGroup>
          </Grid>

        </Grid>
      </Grid>

      <Grid container item lg={12} md={12} xs={12}></Grid>
    </React.Fragment>
  );
}
